<!-- eslint-disable @typescript-eslint/no-use-before-define -->
<template>
    <!-- 新增课程-->
    <vxe-modal
        v-model="formInput.isShow"
        :title="formInput.title"
        width="840"
        height="620"
        @close="closeReqEvent"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                :rules="formInput.formRules"
                title-align="right"
                ref="rForm"
                title-width="60"
            >
                <vxe-form-item
                    title="基本信息"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-address-card-o' }"
                ></vxe-form-item>
                <vxe-form-item
                    title="课程名称"
                    field="course_name"
                    span="24"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.course_name"
                            placeholder="请输入课程名称"
                            clearable
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="课程简介"
                    field="description"
                    span="24"
                    title-width="120px"
                >
                    <vxe-textarea
                        v-model="formInput.formData.description"
                        placeholder="填写课程简介"
                        maxlength="500"
                        show-word-count
                        :disabled="allInputDisable"
                    ></vxe-textarea>
                </vxe-form-item>

                <vxe-form-item
                    title="课程等级"
                    field="course_level"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.course_level"
                            placeholder="请选择课程等级"
                            clearable
                            :disabled="allInputDisable"
                        >
                            <vxe-option value="1" label="基础课程"></vxe-option>
                            <vxe-option value="2" label="中级课程"></vxe-option>
                            <vxe-option value="3" label="高级课程"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="技术分类"
                    field="course_type"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.course_type"
                            placeholder="请选择技术分类"
                            readonly
                            :disabled="allInputDisable"
                            :options="formInput.courseTypes"
                        ></vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="授课日期开始"
                    field="course_start"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            transfer
                            v-model="formInput.formData.course_start"
                            placeholder="请输入授课日期开始"
                            type="date"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="授课日期结束"
                    field="course_end"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            transfer
                            v-model="formInput.formData.course_end"
                            placeholder="请输入授课日期结束"
                            type="date"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="授课方式"
                    field="teach_method"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.teach_method"
                            placeholder="请选择授课方式"
                            clearable
                            :disabled="allInputDisable"
                        >
                            <vxe-option value="1" label="线上"></vxe-option>
                            <vxe-option value="2" label="线下"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="授课地点"
                    field="location"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.location"
                            placeholder="请输入授课地点"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="讲师"
                    field="lecturerNameEmail"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.lecturerNameEmail"
                            placeholder="请选择讲师"
                            readonly
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectUser(0)"
                            :disabled="allInputDisable"
                            >选择</vxe-button
                        >
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="报名方式"
                    field="enroll_method"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.enroll_method"
                            placeholder="请选择报名方式"
                            clearable
                            :disabled="allInputDisable"
                        >
                            <vxe-option value="1" label="CoE门户"></vxe-option>
                            <vxe-option value="2" label="公司OA"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="报名日期开始"
                    field="enroll_start"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            transfer
                            v-model="formInput.formData.enroll_start"
                            placeholder="请输入报名日期开始"
                            type="date"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="报名日期结束"
                    field="enroll_end"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            transfer
                            v-model="formInput.formData.enroll_end"
                            placeholder="请输入报名日期结束"
                            type="date"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="培训学时"
                    field="duration_hours"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            v-model="formInput.formData.duration_hours"
                            placeholder="请输入培训学时"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="报名地址"
                    field="remark"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.remark"
                            placeholder="请输入报名地址"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="实施状态"
                    field="status"
                    span="12"
                    title-width="120px"
                    v-if="editType === '2'"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.status"
                            placeholder="请选择实施状态"
                            clearable
                            :disabled="allInputDisable"
                        >
                            <vxe-option value="0" label="未实施"></vxe-option>
                            <vxe-option value="1" label="已实施"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer v-if="isViewFooter">
            <div style="text-align: center; width: 100%">
                <vxe-button @click="save" icon="fa fa-save" status="success">
                    保存
                </vxe-button>
                <!-- <vxe-button icon="fa fa-close" @click="formInput.isShow = false" status="primary"
                    >取消
                </vxe-button> -->
            </div>
        </template>
    </vxe-modal>
    <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
        <template #default>
            <div>
                <vxe-form>
                    <vxe-form-item title="关键字" :item-render="{}">
                        <template #default>
                            <vxe-input
                                v-model="userTablePager.searchKey"
                                placeholder="请输入姓名或邮箱"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findUserData"
                                @keyup.enter="findUserData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectUser"
                                >确定</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item span="24">
                        <template #title>
                            <span>已选(</span
                            ><span style="color: red">双击选择</span
                            ><span>)</span>
                        </template>
                        <template #default>
                            <div>
                                <template
                                    v-for="(item, index) in formInput.formData
                                        .lecturerIDName"
                                    :key="index"
                                >
                                    <span>{{ item.Name }}</span>
                                    <va-icon
                                        class="icon-left input-icon"
                                        @click="clearUser(item.ID)"
                                        name="clear"
                                    />
                                </template>
                            </div>
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtUser"
                    ref="xTableUser"
                    height="300"
                    @cell-dblclick="chooseUser"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="UserName"
                        title="姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobZb"
                        title="总部"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobName"
                        title="部门"
                        width="120"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="UserMail"
                        title="邮箱"
                        width="200"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="uid"
                        title="uid"
                        width="10"
                        :visible="false"
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="userTablePager.currentPage"
                    v-model:page-size="userTablePager.pageSize"
                    :total="userTablePager.totalResult"
                    @page-change="handlePageChangeUser"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineEmits,
    defineExpose,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";

const { proxy } = getCurrentInstance();

const formInput = reactive({
    title: "新增课程",
    isShow: false,
    courseTypes: [],
    formData: {
        id: "",
        course_name: "",
        course_level: "",
        course_type: "",
        description: "",
        teach_method: "",
        location: "",
        lecturer: "",
        lecturerName: "",
        lecturerNameEmail: "",
        lecturerIDName: [],
        enroll_method: "",
        enroll_start: "",
        enroll_end: "",
        course_start: "",
        course_end: "",
        duration_hours: 0,
        status: "0",
        remark:"",
        saveButDisable: false,
        submitBtnDisable: false,
    },
    formRules: {
        course_name: [{ required: true, message: "课程名称不能为空" }],
        description: [{ required: true, message: "课程简介不能为空" }],
        course_level: [{ required: true, message: "课程等级不能为空" }],
        course_type: [{ required: true, message: "技术分类不能为空" }],
        location: [{ required: true, message: "授课地点不能为空" }],
        teach_method: [{ required: true, message: "授课方式不能为空" }],
        enroll_method: [{ required: true, message: "报名方式不能为空" }],
        enroll_start: [{ required: true, message: "报名日期开始不能为空" }],
        enroll_end: [{ required: true, message: "报名日期结束不能为空" }],
        course_start: [{ required: true, message: "授课日期开始不能为空" }],
        course_end: [{ required: true, message: "授课日期结束不能为空" }],
        duration_hours: [{ required: true, message: "培训学时不能为空" }],
        lecturerNameEmail: [{ required: true, message: "讲师不能为空" }],
    },
});
let allInputDisable = ref(false);
let isViewFooter = ref(true);
let editType = ref("1");
const xTableUser = ref(null);
const rForm = ref(null);

const emit = defineEmits(["flashList"]);

const openModal = async () => {
    formInput.formData = {
        id: proxy.$utils.guid(),
        course_name: "",
        course_level: "",
        course_type: "",
        description: "",
        teach_method: "",
        location: "",
        enroll_method: "",
        enroll_start: "",
        enroll_end: "",
        course_start: "",
        course_end: "",
        duration_hours: "",
        lecturer: "",
        lecturerName: "",
        lecturerNameEmail: "",
        lecturerIDName: [],
        status: "0",
        remark:"",
        saveButDisable: false,
        creator: proxy.$store.state.userID,
    };

    formInput.title = "新增课程";
    formInput.isShow = true;
    allInputDisable.value = false;
    isViewFooter.value = true;
    editType.value = "1";
    const $rForm = rForm.value;

    try {
        if ($rForm) {
            await $rForm.reset();
        }
        // const re = await $rForm.clearValidate();
    } catch (e) {
        console.log(e);
    }
};

const closeReqEvent = () => {
    emit("flashList");
};
let userSelectType = ref(0); //选择用户类型 0 讲师
let userTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});

let iShowSelectUser = ref(false);

//选择用户 type 1 开发人员 2 领导
const selectUser = (type) => {
    userSelectType.value = type;
    userTablePager.searchKey = "";
    findUserData();
    iShowSelectUser.value = true;
};
const confirmSelectUser = () => {
    iShowSelectUser.value = false;
};
let dtUser = ref([]);

const findUserData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: userTablePager.currentPage,
        pageSize: userTablePager.pageSize,
        searchKey: [userTablePager.searchKey, ""],
    };
    proxy.$api.systemManageAPI
        .getUserList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtUser.value = res.data.Data.dataTable;
            userTablePager.currentPage = res.data.Data.currentPage;
            userTablePager.pageSize = res.data.Data.pageSize;
            userTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};

const chooseUser = () => {
    const $table = xTableUser.value;
    if (!$table) {
        console.error("表格实例未找到");
        return;
    }

    const record = $table.getCurrentRecord(); // 获取当前高亮行

    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    //判断是否已选择过
    if (formInput.formData.lecturer.toString() != "") {
        for (let item of formInput.formData.lecturer.toString().split(";")) {
            if (item == record.Id) {
                VXETable.modal.message({
                    content: "该人员已选择",
                    status: "warning",
                });
                return;
            }
        }
    }

    if (
        formInput.formData.lecturerNameEmail == null ||
        formInput.formData.lecturerIDName == ""
    ) {
        formInput.formData.lecturerNameEmail =
            record.UserName + "(" + record.UserMail + ")";
    } else {
        formInput.formData.lecturerNameEmail +=
            ";" + record.UserName + "(" + record.UserMail + ")";
    }

    if (
        formInput.formData.lecturer == null ||
        formInput.formData.lecturer == ""
    ) {
        formInput.formData.lecturer = record.Id;
    } else {
        formInput.formData.lecturer += ";" + record.Id;
    }

    let count = formInput.formData.lecturer.toString().split(";").length;

    formInput.formData.lecturerIDName = [];

    for (let i = 0; i < count; i++) {
        formInput.formData.lecturerIDName.push({
            Name: formInput.formData.lecturerNameEmail.toString().split(";")[i],
            ID: formInput.formData.lecturer.toString().split(";")[i],
        });
    }
};

//删除用户
const clearUser = (userid) => {
    let idx = -1;
    formInput.formData.lecturerIDName.forEach(function (item, index, arr) {
        if (item.ID == userid) {
            idx = index;
        }
    });
    let tmpId = [],
        tmpname = [];
    tmpId = formInput.formData.lecturer.toString().split(";");
    tmpname = formInput.formData.lecturerNameEmail.toString().split(";");
    tmpId.splice(idx, 1);
    tmpname.splice(idx, 1);
    formInput.formData.lecturer = tmpId.join(";");
    formInput.formData.lecturerNameEmail = tmpname.join(";");
    let count = 0;
    if (formInput.formData.lecturer.toString() != "") {
        count = formInput.formData.lecturer.toString().split(";").length;
    }
    formInput.formData.lecturerIDName = [];
    //debugger
    for (let i = 0; i < count; i++) {
        formInput.formData.lecturerIDName.push({
            Name: formInput.formData.lecturerNameEmail.toString().split(";")[i],
            ID: formInput.formData.lecturer.toString().split(";")[i],
        });
    }
};

//保存新课程
const save = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }
    const params = getModel();

    if (formInput.formData.saveButDisable) {
        return;
    }

    //新增
    if (editType.value === "1") {
        proxy.$api.courseManageAPI
            .addCourse(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
                formInput.isShow = false;
                emit("flashList");
            })
            .catch((error) => {
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "2") {
        //更新
        proxy.$api.courseManageAPI
            .updateCourse(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
                formInput.isShow = false;
                emit("flashList");
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};
const getModel = () => {
    const course = {
        id: formInput.formData.id,
        course_name: formInput.formData.course_name,
        course_level: formInput.formData.course_level,
        course_type: formInput.formData.course_type,
        description: formInput.formData.description,
        teach_method: formInput.formData.teach_method,
        location: formInput.formData.location,
        lecturer: formInput.formData.lecturer,
        enroll_method: formInput.formData.enroll_method,
        enroll_start: formInput.formData.enroll_start,
        enroll_end: formInput.formData.enroll_end,
        course_start: formInput.formData.course_start,
        course_end: formInput.formData.course_end,
        duration_hours: formInput.formData.duration_hours,
        status: formInput.formData.status,
        creator: formInput.formData.creator,
        create_time: formInput.formData.create_time,
        remark:formInput.formData.remark
    };
    return course;
};
let submitLoading = ref(false);

const handlePageChangeUser = () => {
    findUserData();
};

// type 1 新增 2 编辑
const editEvent = async (row, type) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.id],
    };
    proxy.$api.courseManageAPI
        .getCourseOne(Qs.stringify(params))
        .then(async (res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.formData = res.data.Data;

            formInput.title = "编辑课程";
            allInputDisable.value = false;
            isViewFooter.value = true;

            editType.value = "2"; //更新
            const userIds = formInput.formData.lecturer.toString().split(";");
            const userNames = formInput.formData.lecturerNameEmail
                .toString()
                .split(";");
            formInput.formData.lecturerIDName = userIds.map((id, i) => ({
                Name: userNames[i],
                ID: id,
            }));
            formInput.isShow = true;
            const $rForm = rForm.value;
            try {
                if ($rForm) {
                    await $rForm.reset();
                }
                // const re = await $rForm.clearValidate();
            } catch (e) {
                console.log(e);
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindCourseType = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: "",
        pageSize: "",
        searchKey: ["32"],
    };
    proxy.$api.systemManageAPI
        .getLookupValue(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            formInput.courseTypes = [];
            for (const item of res.data.Data) {
                formInput.courseTypes.push({
                    value: item.LookupValueCode,
                    label: item.LookupValueName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
onMounted(() => {
    setTimeout(() => {
        bindCourseType();
    }, 10);
});

defineExpose({ openModal, editEvent });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
